'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BBBOZKTU.mjs";

// src/gift/GiftIcon.tsx
import { jsx } from "react/jsx-runtime";
var GiftIcon = (props) => {
  return /* @__PURE__ */ jsx(
    "svg",
    __spreadProps(__spreadValues({
      width: "14",
      height: "12",
      viewBox: "0 0 14 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.333008 1.1665C0.333008 0.890362 0.556865 0.666504 0.833008 0.666504H13.1663C13.4425 0.666504 13.6663 0.890362 13.6663 1.1665V10.8332C13.6663 11.1093 13.4425 11.3332 13.1663 11.3332H0.833008C0.556865 11.3332 0.333008 11.1093 0.333008 10.8332V1.1665ZM1.33301 6.49984V10.3332H7.83301V7.20694L6.85323 8.18672C6.65797 8.38199 6.34138 8.38199 6.14612 8.18672C5.95086 7.99146 5.95086 7.67488 6.14612 7.47962L7.1259 6.49984H1.33301ZM8.83301 7.20694V10.3332H12.6663V6.49984H9.54011L10.5199 7.47962C10.7152 7.67488 10.7152 7.99146 10.5199 8.18672C10.3246 8.38199 10.008 8.38199 9.81279 8.18672L8.83301 7.20694ZM9.54011 5.49984H12.6663V1.6665H8.83301V4.79273L9.81279 3.81295C10.008 3.61769 10.3246 3.61769 10.5199 3.81295C10.7152 4.00821 10.7152 4.32479 10.5199 4.52006L9.54011 5.49984ZM7.83301 4.79273V1.6665H1.33301V5.49984H7.1259L6.14612 4.52006C5.95086 4.32479 5.95086 4.00821 6.14612 3.81295C6.34138 3.61769 6.65797 3.61769 6.85323 3.81295L7.83301 4.79273Z",
          fill: "currentColor"
        }
      )
    })
  );
};

export {
  GiftIcon
};
//# sourceMappingURL=chunk-EJ6YSYKO.mjs.map